import ApiClientFactory from '../../../api/client-factory';
import { SettingsApiStoreSettingsService } from './service';

const service = new SettingsApiStoreSettingsService(ApiClientFactory());

export function SettingsApiStoreSettingsServiceFactory(): typeof service {
  return service;
}
